export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
              精彩看点
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              精彩预告
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              抢先了解最新剧集精彩看点与幕后花絮
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            <div className="group bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="relative h-44 md:h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20moment%20from%20a%20Chinese%20TV%20drama%2C%20emotional%20confrontation%20between%20characters%2C%20warm%20cinematic%20lighting%2C%20intense%20expressions%2C%20film%20grain%20texture%2C%20professional%20cinematography&width=600&height=400&seq=media-card-01&orientation=landscape"
                  alt="繁华似锦大结局预告"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-50/80 text-xs font-medium text-foreground-700">预告片</span>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-50/60 text-xs text-foreground-500">03:25</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-400 transition-colors">《繁华似锦》大结局抢先看</h3>
                <p className="text-xs text-foreground-500">主角命运走向引热议，催泪结局不容错过</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="relative h-44 md:h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20Korean%20drama%20filming%2C%20director%20and%20actors%20on%20set%2C%20professional%20camera%20equipment%2C%20warm%20lighting%2C%20casual%20atmosphere%2C%20cinematic%20documentary%20style&width=600&height=400&seq=media-card-02&orientation=landscape"
                  alt="逆光之恋拍摄花絮"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/90 text-background-50 group-hover:bg-accent-500 transition-colors shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-50/80 text-xs font-medium text-foreground-700">花絮</span>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-50/60 text-xs text-foreground-500">05:12</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-400 transition-colors">《逆光之恋》幕后花絮</h3>
                <p className="text-xs text-foreground-500">男女主角甜蜜互动NG合集曝光</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="relative h-44 md:h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Cast%20interview%20for%20a%20Chinese%20historical%20drama%2C%20actors%20in%20elaborate%20costumes%20speaking%2C%20studio%20interview%20setting%2C%20warm%20professional%20lighting%2C%20cinematic%20portrait%20style&width=600&height=400&seq=media-card-03&orientation=landscape"
                  alt="长安十二时辰主创访谈"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500/90 text-background-50 group-hover:bg-secondary-500 transition-colors shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-50/80 text-xs font-medium text-foreground-700">访谈</span>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-50/60 text-xs text-foreground-500">12:48</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-400 transition-colors">《长安十二时辰》主创访谈</h3>
                <p className="text-xs text-foreground-500">导演揭秘4K修复版背后故事</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="relative h-44 md:h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Highlight%20reel%20compilation%20of%20best%20TV%20drama%20moments%2C%20emotional%20scenes%20montage%2C%20dramatic%20lighting%2C%20cinematic%20color%20grading%2C%20various%20genres%20blended%2C%20epic%20atmosphere&width=600&height=400&seq=media-card-04&orientation=landscape"
                  alt="月度精彩集锦"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-50/80 text-xs font-medium text-foreground-700">集锦</span>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-50/60 text-xs text-foreground-500">08:30</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-400 transition-colors">七月剧集精彩集锦</h3>
                <p className="text-xs text-foreground-500">本月最值得回味的十大名场面</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}